import { inject } from '@angular/core';
import { CrmSurveyService, ImageConversionService } from '@core/services';
import { CrmSurveyEntity, CrmSurveysListEntity, Pagination } from '@core/entities';
import { map } from 'rxjs/operators';
import { plainToInstance } from 'class-transformer';
import { Observable } from 'rxjs';
import { GetUserId } from '@core/utils';

export class UseCRMSurvey {
  private readonly _crmSurveyService = inject(CrmSurveyService);
  private readonly _imageConversionService = inject(ImageConversionService);

  getActiveSurveys(pagination: Pagination): Observable<CrmSurveysListEntity> {
    return this._crmSurveyService.getActiveSurveys(pagination).pipe(
      map((response: any) => {
        const res = {
          pagination: {
            page: +response.pagination.page,
            pageSize: +response.pagination.pageSize,
            rowCount: +response.pagination.rowCount,
            pageCount: Math.ceil(+response.pagination.rowCount / +response.pagination.pageSize),
          },
          surveys: response.survey.map((survey: any) => {
            const transformedSurvey = plainToInstance(CrmSurveyEntity, survey);
            if (transformedSurvey.picture) {
              transformedSurvey.imageUrl = this._imageConversionService.convertBase64ToSafeUrl(transformedSurvey.picture);
            }
            return transformedSurvey;
          }),
        };

        return res as CrmSurveysListEntity;
      }),
    );
  }

  getMySurveys(pagination: Pagination): Observable<CrmSurveysListEntity> {
    return this._crmSurveyService.getMyVotedSurveys(+GetUserId(), pagination).pipe(
      map((response: any) => {
        const res = {
          pagination: {
            page: +response.pagination.page,
            pageSize: +response.pagination.pageSize,
            rowCount: +response.pagination.rowCount,
            pageCount: Math.ceil(+response.pagination.rowCount / +response.pagination.pageSize),
          },
          surveys: response.survey.map((survey: any) => {
            const transformedSurvey = plainToInstance(CrmSurveyEntity, survey);
            if (transformedSurvey.picture) {
              transformedSurvey.imageUrl = this._imageConversionService.convertBase64ToSafeUrl(transformedSurvey.picture);
            }
            return transformedSurvey;
          }),
        };

        return res as CrmSurveysListEntity;
      }),
    );
  }

  getCompletedSurveys(pagination: Pagination): Observable<CrmSurveysListEntity> {
    return this._crmSurveyService.getCompletedSurveys(pagination).pipe(
      map((response: any) => {
        const res = {
          pagination: {
            page: +response.pagination.page,
            pageSize: +response.pagination.pageSize,
            rowCount: +response.pagination.rowCount,
            pageCount: Math.ceil(+response.pagination.rowCount / +response.pagination.pageSize),
          },
          surveys: response.survey.map((survey: any) => {
            const transformedSurvey = plainToInstance(CrmSurveyEntity, survey);
            if (transformedSurvey.picture) {
              transformedSurvey.imageUrl = this._imageConversionService.convertBase64ToSafeUrl(transformedSurvey.picture);
            }
            return transformedSurvey;
          }),
        };

        return res as CrmSurveysListEntity;
      }),
    );
  }

  getSurveyDetails(surveyId: number): Observable<CrmSurveyEntity> {
    return this._crmSurveyService.getSurveyById(surveyId).pipe(
      map((response: any) => {
        const transformedSurvey = plainToInstance(
          CrmSurveyEntity,
          response.survey.find((survey: any) => survey.id === surveyId),
        );
        if (transformedSurvey.picture) {
          transformedSurvey.imageUrl = this._imageConversionService.convertBase64ToSafeUrl(transformedSurvey.picture);
        }
        return transformedSurvey;
      }),
    );
  }
}
